import LockupFilesIncluded from './lockupFilesIncluded'

export default LockupFilesIncluded
